import { useQuery } from 'react-query';
import { getTableEntries } from '../../modules/tables/tables.repository';
import { SortOrders } from '../../stores/types';

export const useEntriesFiltering = (
  databaseSlug: string,
  tableSlug: string,
  pageSize: number,
  fieldName: string, // to prevent query from firing multiple times accross the table
  searchQuery?: string,
  sorting?: [string, SortOrders],
  enabled?: boolean,
) => {
  const { data, isLoading } = useQuery(['filterEntries', databaseSlug, tableSlug, fieldName, searchQuery], async () => {
    const entries = await getTableEntries(
      databaseSlug,
      tableSlug,
      { page: 1, perPage: pageSize },
      searchQuery,
      sorting,
    );
    return entries;
  }, { enabled: !!tableSlug && enabled });
  return {
    data,
    isLoading,
  };
};
